export enum ACTION_TYPES {
  ORDER = 'ORD',
}

export enum ORDER_ACTIONS {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
  CANCEL = 'CANCEL',
  ONHOLD = 'ONHOLD',
  RESUME = 'RESUME',
  REPEAT = 'REPEAT',
}
